function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rectangle Copy 2");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30DE\\u30A4\\u30DA\\u30FC\\u30B8\\u30C7\\u30B6\\u30A4\\u30F3",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "NIL-2-NINAL\\u3054\\u5229\\u7528\\u30FB\\u3054\\u5951\\u7D04\\u72B6\\u6CC1mobile",
  transform: "translate(-27.000000, -895.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(0.000000, 753.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(20.000000, 62.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(0.000000, 72.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(7.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#E2E2E2",
  strokeWidth: 0.5,
  cx: 12.5,
  cy: 12.5,
  r: 10.25
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#ACACAC",
  cx: 12.5,
  cy: 12.5,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5,11.5 C3.83333333,5.5 7.16666667,2.5 12.5,2.5",
  id: "Path",
  stroke: "#979797",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))))));

var SvgLens = function SvgLens(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "-7.8 -7.8 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLens, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lens.c3d68cc6.svg";
export { ForwardRef as ReactComponent };